import React from 'react';
export const ManagedBroadcastConfirmationHeader = () => {
  return <>Confirmation</>;
};